import React, { useEffect, useState } from 'react';
import { Col, FormGroup, Modal, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, set } from 'lodash';
import { useTranslation } from 'react-i18next';
import { currencyCodes, customStyles } from '../../../Components/helper';

import * as componentAction from '../store/component.action';
import { CloseIcon } from '../../../bombiix-icon';

function AddPurchaseOrder({ onOpen, toggle }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const reducerState = useSelector((redState) => redState);
  const {
    ComponentOrderReducer: { supplierType, supplierList, poListData },
  } = reducerState;

  const [state, setState] = useState({
    selectedColours: [],
    selectedSupplier: null,
    selectedSupplierType: null,
    selectedTemplate: null,
    selectedCurrency: null,
    currOptions: [],
    templateJsonSchema: [],
    supplierTypeOpt: [],
    supplierListOpt: [],
    loading: false,
    poOrderNo: '',
    showError: false,
  });
  const {
    selectedSupplier,
    selectedTemplate,
    supplierListOpt,
    supplierTypeOpt,
    currOptions,
    selectedCurrency,
    selectedSupplierType,
    poOrderNo,
    templateJsonSchema,
  } = state;

  useEffect(() => {
    return () => {
      dispatch(componentAction.clearReducer());
    };
  }, [dispatch]);
  useEffect(() => {
    if (currencyCodes) {
      const manipulatedCurrency = currencyCodes.map((code) => {
        return {
          value: code,
          label: code,
        };
      });
      setState((prevState) => ({
        ...prevState,
        currOptions: manipulatedCurrency,
      }));
    }
  }, []);

  useEffect(() => {
    if (supplierType.length)
      setState((prevState) => ({
        ...prevState,
        supplierTypeOpt: supplierType,
        supplierListOpt: supplierList,
        templateJsonSchema: poListData,
      }));
  }, [supplierType, supplierList, poListData]);

  useEffect(() => {
    const callSupplier = async () => {
      const reqObj = {
        isActive: true,
      };
      await dispatch(componentAction.getProductAssociatesAction());
      await dispatch(componentAction.fetchPOTemplateList(reqObj));
    };
    callSupplier();
  }, []);

  const selectSupplierDropDown = async (selected) => {
    setState((prev) => ({
      ...prev,
      selectedSupplierType: selected,
    }));
    await dispatch(componentAction.getSupplierListBasedONType(selected._id));
  };

  const handleSelectChange = async (value, keyName) => {
    const copyState = state;
    set(copyState, keyName, value);
    setState((prevState) => ({ ...prevState, ...copyState }));
  };

  const handleSubmitData = async () => {
    if (
      !isEmpty(state.poOrderNo) &&
      !isEmpty(state.selectedSupplier) &&
      !isEmpty(state.selectedCurrency) &&
      !isEmpty(state.selectedTemplate) &&
      !isEmpty(state.selectedSupplierType)
    ) {
      const reqObj = {
        supplierId: selectedSupplier._id,
        poTemplateId: selectedTemplate._id,
        supplierType: selectedSupplierType.name,
        purchaseOrderId: poOrderNo,
        currency: selectedCurrency.value,
      };
      const res = await dispatch(componentAction.addPurachseOrder(reqObj, t));
      if (res) {
        toggle();
      }
    } else {
      setState((errState) => ({
        ...errState,
        showError: true,
      }));
    }
  };

  return (
    <Modal show={onOpen} backdrop="static" className="custom-modal modal-medium-2x" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{t('PURCHASE_ORDER_NUMBER.ADD_ORDER')}</span>
          </Modal.Title>
          <button type="button" onClick={toggle} className="btn">
            <CloseIcon size={28} className="cursor-pointer" />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          <Row>
            <Col lg={4}>
              <FormGroup>
                <div className="input-group form-floating-label-po fixed-label title-input">
                  <label className="asterisk-req">
                    {t('PURCHASE_ORDER_NUMBER.ORDER_NUMBER')}
                    <span>*</span>
                  </label>
                  <input
                    className="form-control"
                    autoComplete="off"
                    placeholder={t('PURCHASE_ORDER_NUMBER.ORDER_NUMBER')}
                    type="text"
                    name="poOrderNo"
                    value={poOrderNo}
                    onChange={(e) => handleSelectChange(e.target.value.trimStart(), 'poOrderNo')}
                  />
                </div>
                {state?.showError && !state?.poOrderNo && <small className="error-message">{t('PURCHASE_ORDER_NUMBER.REQUIRED')}</small>}
              </FormGroup>
            </Col>
            <Col lg={4}>
              <FormGroup className="flex-fill">
                <div className="custom-react-select">
                  <label className="asterisk-req">
                    {t('PURCHASE_ORDER_NUMBER.SELECT_SUPLIER_TYPE')}
                    <span>*</span>
                  </label>
                  <Select
                    name="Supplier"
                    type="text"
                    placeholder={t('PURCHASE_ORDER_NUMBER.SELECT_SUPLIER')}
                    options={supplierTypeOpt}
                    styles={customStyles}
                    getOptionLabel={({ name }) => `${name}`}
                    getOptionValue={({ name }) => `${name}`}
                    value={selectedSupplierType}
                    onChange={(selected) => selectSupplierDropDown(selected)}
                  />
                </div>
                {state?.showError && !state?.selectedSupplierType && (
                  <small className="error-message">{t('PURCHASE_ORDER_NUMBER.SUPPLIER_TYPE_REQUIRED')}</small>
                )}
              </FormGroup>
            </Col>
            <Col lg={4}>
              <FormGroup className="flex-fill">
                <div className="custom-react-select">
                  <label className="asterisk-req">
                    {t('PURCHASE_ORDER_NUMBER.SELECT')}
                    <span>*</span>
                  </label>
                  <Select
                    name="Supplier"
                    type="text"
                    placeholder={t('PURCHASE_ORDER_NUMBER.SELECT_SUPLIER')}
                    styles={customStyles}
                    options={supplierListOpt}
                    getOptionLabel={({ supplierName }) => `${supplierName}`}
                    getOptionValue={({ supplierName }) => `${supplierName}`}
                    value={selectedSupplier || null}
                    onChange={(selected) => handleSelectChange(selected, 'selectedSupplier')}
                  />
                </div>
                {state?.showError && !state?.selectedSupplier && <small className="error-message">{t('PURCHASE_ORDER_NUMBER.SUPPLIER_REQUIRED')}</small>}
              </FormGroup>
            </Col>

            <Col lg={4}>
              <FormGroup className="flex-fill">
                <div className="custom-react-select">
                  <label className="asterisk-req">
                    {t('PURCHASE_ORDER_NUMBER.CURRENCY')}
                    <span>*</span>
                  </label>
                  <Select
                    name="Currency"
                    type="text"
                    placeholder={t('PURCHASE_ORDER_NUMBER.CURRENCY')}
                    options={currOptions}
                    getOptionLabel={({ label }) => `${label}`}
                    getOptionValue={({ label }) => `${label}`}
                    value={selectedCurrency || null}
                    styles={customStyles}
                    onChange={(selected) => handleSelectChange(selected, 'selectedCurrency')}
                  />
                </div>
                {state?.showError && !state?.selectedCurrency && <small className="error-message">{t('PURCHASE_ORDER_NUMBER.CURRENCY_REQUIRED')}</small>}
              </FormGroup>
            </Col>
            <Col lg={4}>
              <FormGroup className="flex-fill">
                <div className="custom-react-select">
                  <label className="asterisk-req">
                    {t('PURCHASE_ORDER_NUMBER.PO_TEM')}
                    <span>*</span>
                  </label>
                  <Select
                    name="Template"
                    type="text"
                    placeholder={t('PURCHASE_ORDER_NUMBER.PO_TEM')}
                    options={templateJsonSchema}
                    getOptionLabel={({ name }) => `${name}`}
                    getOptionValue={({ name }) => `${name}`}
                    value={selectedTemplate || null}
                    styles={customStyles}
                    onChange={(selected) => handleSelectChange(selected, 'selectedTemplate')}
                  />
                </div>
                {state?.showError && !selectedTemplate && <small className="error-message">{t('PURCHASE_ORDER_NUMBER.PO_TEMPLATE_REQUIRED')}</small>}
              </FormGroup>
            </Col>
          </Row>
          <div className="modal-buttons mt-5 d-flex justify-content-between">
            <button className="btn btn-default" type="button" onClick={toggle}>
              {t('COMMON_LABEL.CANCEL')}
            </button>
            <button
              className="btn btn-default"
              type="button"
              onClick={() => {
                handleSubmitData();
              }}
            >
              {t('COMMON_LABEL.ADD')}
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
}

export default AddPurchaseOrder;
